var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full flex flex-col justify-center items-center"},[_c('h2',{staticClass:"absolute left-9 top-6 font-bold text-lg"},[_vm._v("Créditos")]),_c('div',[_c('app-in-construction')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }